// Format as `<amount> ج.م` — plain concatenation instead of
// Intl.NumberFormat's currency style, because the built-in EGP
// abbreviation ends in a period (`ج.م.`), and RTL bidi rendering
// occasionally attaches that closing period next to the digit
// (visually rendering `٠. ج.م.` instead of `٠ ج.م.`). Dropping the
// currency-style call sidesteps the whole RTL glitch, and the trailing
// period is not part of the standard shorthand.
export function formatEgp(value: number): string {
  return `${new Intl.NumberFormat('ar-EG', { maximumFractionDigits: 0 }).format(value)} ج.م`;
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('ar-EG').format(value);
}

// كل التواريخ في الأدمن بتتعرض بتوقيت مصر (Africa/Cairo) بغض النظر
// عن مكان الأدمن أو إعدادات المتصفح. Intl بيتعامل مع التوقيت الشتوي/
// الصيفي أوتوماتيك عن طريق tzdata، فمافيش لازمة نظبطها يدوي.
const CAIRO_TZ = 'Africa/Cairo';

// Arabic month names + Latin (Western) digits. Operator asked for
// clearer numbers in the chat timestamps (2026-09-17): the Arabic-
// Indic ١٠ next to a colon was hard to read at small sizes because
// the ١ and ٠ visually blend with the punctuation. `numberingSystem:
// 'latn'` keeps months like "سبتمبر" in Arabic but writes the day,
// year, and time in Latin digits (10:21, 2026, 17). Same locale +
// timezone so the rest of the format stays consistent.
export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('ar-EG-u-nu-latn', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: CAIRO_TZ,
  }).format(new Date(iso));
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('ar-EG-u-nu-latn', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: CAIRO_TZ,
  }).format(new Date(iso));
}
